import {Row} from 'antd';
import React from 'react';
import {isMobile} from 'react-device-detect';
import styled from 'styled-components';
import {colorPalette} from '../../../config';
import {Button, Ul} from '../../Atom';
import {
	RadioForm,
	SelectForm,
	InputForm,
	GroupForm,
	PhoneInput,
	EmailInput,
	InputNumberForm,
} from '../../Organism';
import * as S from './style';
import V2GroupTable from './V2GroupTable';

const InputGenerator = ({input, info, setInfo}) => {
	switch (input.type) {
		case 'email':
			return <EmailInput {...input} info={info} setInfo={setInfo} />;
		case 'phone':
			return <PhoneInput {...input} info={info} setInfo={setInfo} />;
		case 'input':
			return <InputForm {...input} />;
		case 'radio':
			return <RadioForm {...input} />;
		case 'select':
			return <SelectForm {...input} />;
		case 'inputnumber':
			return <InputNumberForm {...input} info={info} setInfo={setInfo} />;
	}
};

const PersonForm = ({
	terms,
	uls,
	inputs,
	button,
	group,
	isV2Group,
	newGroup,
	submitButton,
	setNewGroup,
	info,
	setInfo,
	isUpdate,
	isInfoText = false,
	vInfoText = false,
}) => {
	return (
		<S.Container>
			{terms && <S.TermsWrapper></S.TermsWrapper>}
			{uls && (
				<S.UlWrapper>
					<Ul {...uls} />
				</S.UlWrapper>
			)}
			{inputs.map((input, index, array) => {
				return (
					<S.InputWrapper key={index}>
						<InputGenerator
							input={input}
							info={info}
							setInfo={setInfo}
						/>
					</S.InputWrapper>
				);
			})}

			{group && (
				<>
					{isV2Group ? (
						<>
							<V2GroupTable
								newGroup={newGroup}
								setNewGroup={setNewGroup}
								isUpdate={isUpdate}
							/>
							<S.ButtonWrapper>
								<Button {...button} onClick={submitButton} />
							</S.ButtonWrapper>
						</>
					) : (
						<S.GroupFormWrapper>
							<GroupForm {...group} />
						</S.GroupFormWrapper>
					)}
				</>
			)}
			{!isV2Group && button && (
				<>
					{/* 기념품이 티셔츠가 될 경우를 대비하여 사이즈를 수집합니다. */}
					{isInfoText && (
						<InfoText>
							{isMobile ? (
								<>
									* 기념품이 결정되면 홈페이지에 공지하며
									결정된 기념품으로 변경 가능합니다.
									<br /><br />* 비밀번호는 숫자 4자리로 설정
									가능합니다.
									<InfoRedText>* 동명이인 확인을 위해 입금자명에 &apos;성명+생년월일&apos;을 기재 후 송금바랍니다.</InfoRedText>
								</>
							) : (
								<>
									* 기념품이 결정되면 홈페이지에 공지하며
									결정된 기념품으로 변경 가능합니다.
									<br />
									<br />* 비밀번호는 숫자 4자리로 설정
									가능합니다.
									<br />
									<InfoRedText>* 동명이인 확인을 위해 입금자명에 &apos;성명+생년월일&apos;을 기재 후 송금바랍니다.</InfoRedText>
								</>
							)}
						</InfoText>
					)}

					{vInfoText && (
						<InfoText>
							1365 ID를 작성하지 않을 시 봉사 시간이 부여되지 않을
							수 있습니다.
						</InfoText>
					)}

					<S.ButtonWrapper>
						<Button {...button} />
					</S.ButtonWrapper>
				</>
			)}
		</S.Container>
	);
};

export default PersonForm;

const InfoText = styled.p({
	color: colorPalette.primary,
	fontSize: 16,
});

const InfoRedText = styled.p({
	color: colorPalette.invalid,
	fontSize: 16,
});
